/* eslint-disable no-extend-native */
// eslint-disable-next-line no-restricted-globals
// Keep this import synchronous: prototype consumers can run while page modules are evaluated.
// eslint-disable-next-line global-require
const uuid = require("uuid") as typeof import("uuid");

String.prototype.generateUUID = (): string => uuid.v4();
